var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Weight 404"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5705_41884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5705_41884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_box",
    d: "M4.16667 14.875C4.91667 14.1389 5.78819 13.559 6.78125 13.1354C7.77431 12.7118 8.84722 12.5 10 12.5C11.1528 12.5 12.2257 12.7118 13.2188 13.1354C14.2118 13.559 15.0833 14.1389 15.8333 14.875V4.16667H4.16667V14.875ZM10 10.8333C10.8056 10.8333 11.4931 10.5486 12.0625 9.97917C12.6319 9.40972 12.9167 8.72222 12.9167 7.91667C12.9167 7.11111 12.6319 6.42361 12.0625 5.85417C11.4931 5.28472 10.8056 5 10 5C9.19444 5 8.50694 5.28472 7.9375 5.85417C7.36806 6.42361 7.08333 7.11111 7.08333 7.91667C7.08333 8.72222 7.36806 9.40972 7.9375 9.97917C8.50694 10.5486 9.19444 10.8333 10 10.8333ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM5.83333 15.8333H14.1667V15.625C13.5833 15.1389 12.9375 14.7743 12.2292 14.5312C11.5208 14.2882 10.7778 14.1667 10 14.1667C9.22222 14.1667 8.47917 14.2882 7.77083 14.5312C7.0625 14.7743 6.41667 15.1389 5.83333 15.625V15.8333ZM10 9.16667C9.65278 9.16667 9.35764 9.04514 9.11458 8.80208C8.87153 8.55903 8.75 8.26389 8.75 7.91667C8.75 7.56944 8.87153 7.27431 9.11458 7.03125C9.35764 6.78819 9.65278 6.66667 10 6.66667C10.3472 6.66667 10.6424 6.78819 10.8854 7.03125C11.1285 7.27431 11.25 7.56944 11.25 7.91667C11.25 8.26389 11.1285 8.55903 10.8854 8.80208C10.6424 9.04514 10.3472 9.16667 10 9.16667Z",
    fill: "#475467"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.ca58473b5a8ce45b28a220d887021306.svg";
export { ForwardRef as ReactComponent };